<form [formGroup]="form">
    <ng-container class="container-fluid">
        <mat-form-field [hideRequiredMarker]="!showLabel" *ngIf="!!items" class="full-width">
            <mat-label *ngIf="!showBoldLabel && showLabel">{{ label }}</mat-label>
            <mat-label style="font-weight: bold;" *ngIf="showBoldLabel">{{ label }}</mat-label>
            <mat-select (openedChange)="izmeniPrikazLabele($event)" [disabled]="disabled" #selector
                [(ngModel)]="selectedItem" formControlName="selectedItem" (selectionChange)="onChange($event)"
                [multiple]="selectMultiple" matTooltip="{{tooltipText}}"
                (keydown.enter)="zatvoriSelect($event, selector)">
                <mat-form-field
                    style="width: 95%; padding-left: 2.2%;  position:sticky; top:0; z-index:1; background-color: white;">
                    <input autocomplete="off" type="text" matInput formControlName="search" placeholder="Претрага"
                        (keyup.enter)="search()" (keydown)="$event.stopPropagation()">
                    <button mat-button mat-icon-button matSuffix (click)="search()">
                        <mat-icon>search</mat-icon>
                    </button>
                </mat-form-field>
                <mat-divider></mat-divider>
                <mat-option style="display: none;"></mat-option>
                <mat-option *ngFor="let item of items;" [value]='item'>
                    {{ getValue(item) }}
                </mat-option>
                <mat-divider></mat-divider>
                <a style="width: 100%;" mat-button (click)="loadNext()" [disabled]="isDisabled()">Учитај још</a>
            </mat-select>
            <button *ngIf="!disabled" type="button" mat-button mat-icon-button matSuffix (click)="empty()">
                <mat-icon matTooltip="{{ 'general.ukloni' | translate }}">close</mat-icon>
            </button>
            <mat-error *ngIf="form.invalid" class="alert">
                <span *ngIf="this.form.get('selectedItem').errors['required']" class="alert">
                    {{ "features.sluzbenaEvidencija.osnovniPodaci.obaveznoPolje" | translate: {
                    attributName:label } }}
                </span>
            </mat-error>
        </mat-form-field>
    </ng-container>
</form>